import React, { useState, useEffect } from 'react';
import { FaMicrophone, FaComments } from 'react-icons/fa';
import './chat.css';
import tuhaitoh from './songs/tuhaitoh.mp3';
import apnabanale from './songs/apnabanale.mp3';
import diewithasmile from './songs/diewithasmile.mp3';


function Chat() {
  const [userInput, setUserInput] = useState('');
  const [isListening, setIsListening] = useState(false);
  const [songUrl, setSongUrl] = useState(''); // Store the audio file URL
  const [model, setModel] = useState(null); // Store the model

  // Initialize the Speech Recognition API (Web Speech API)
  const recognition = new (window.SpeechRecognition || window.webkitSpeechRecognition)();
  recognition.lang = 'en-US';
  recognition.interimResults = true;

  const startListening = () => {
    setIsListening(true);
    recognition.start();
  };

  recognition.onresult = (event) => {
    const current = event.resultIndex;
    const transcript = event.results[current][0].transcript;
    setUserInput(transcript);
  };

  recognition.onend = () => {
    setIsListening(false);
  };

  useEffect(() => {
    const loadModel = async () => {
      const toxicityModel = await import('@tensorflow-models/toxicity');
      const loadedModel = await toxicityModel.load();
      setModel(loadedModel);
    };
    loadModel();
  }, []);

  const detectEmotion = async (text) => {
    if (!model) {
      console.error('Model not loaded yet');
      return 'neutral';
    }
  
    try {
      const predictions = await model.classify(text);
      console.log('Predictions:', predictions);
  
      // Check for toxicity
      const toxic = predictions.some(pred => pred.label === 'toxicity' && pred.results[0].match);
  
      // Simulate emotion detection
      let detectedEmotion = 'neutral';
      if (toxic) {
        detectedEmotion = 'angry';
      } else if (text.match(/happy|great|good|wonderful|joy/i)) {
        detectedEmotion = 'happy';
      } else if (text.match(/sad|upset|down|bad/i)) {
        detectedEmotion = 'sad';
      }
  
      generateRandomSong(detectedEmotion);
      return detectedEmotion;
    } catch (error) {
      console.error('Error detecting emotion:', error);
      generateRandomSong('neutral');
      return 'neutral';
    }
  };
  

  const generateRandomSong = (emotion) => {
    const songs = {
      happy: [apnabanale],
      angry: [diewithasmile],
      neutral: [tuhaitoh],
      sad:[diewithasmile],
    };

    const songList = songs[emotion] || songs.neutral;
    const randomSong = songList[Math.floor(Math.random() * songList.length)];
    setSongUrl(randomSong);
  };

  const handleSubmit = async () => {
    await detectEmotion(userInput);
  };

  return (
    <div className="chat">
      <div className="chat-container">
        <div className="chat-ai">
          <FaComments className="chat-bubble" />
          <p>Hey friend, how are you feeling now?</p>
        </div>
        <div className="input-container">
          <textarea
            className="user-input"
            placeholder="Share your thoughts..."
            value={userInput}
            onChange={(e) => setUserInput(e.target.value)}
          ></textarea>
          <button className="voice-btn" onClick={startListening}>
            <FaMicrophone />
          </button>
        </div>
        <button className="submit-btn" onClick={handleSubmit}>Submit</button>

        {songUrl && (
          <div className="song-result">
            <h3>Here's a song based on your emotion! 😊</h3>
            <audio controls>
              <source src={songUrl} type="audio/mpeg" />
              Your browser does not support the audio element.
            </audio>
          </div>
        )}
      </div>
    </div>
  );
}

export default Chat;
